// extracted by mini-css-extract-plugin
export var circle = "_bp-1";
export var exitConfirmationModal = "_bp-5";
export var iframe = "_bp-0";
export var offline = "_bp-3";
export var online = "_bp-2";
export var workstationSelectError = "_bp-4";